export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.user-management': '用户',
  'menu.tag-management': '标签',
  'menu.canned-response': '罐装回复',
  'menu.chatrooms': '聊天室',
  'menu.email': '邮件',
  'menu.core': '核心功能',
  'menu.files': '文件',
  'menu.library': '提示库',
  'menu.chat': '聊天',
  'menu.search': '搜索',
  'menu.specialised': '专业',
  'menu.app': '分析',
  'menu.playbook': '编排指南',
  'menu.template': '自定义输出',
  'menu.quote': '引用',
  'menu.review': '审查',
  'menu.sideBySide': '并排',
  'menu.grading': '评分',
  'menu.setting': '设置',
  'menu.diagnostics': '诊断',
  'menu.context': '上下文',
  'menu.management': '管理',
  'menu.conversation': '对话',
  'menu.broadcast': '广播',
  'menu.dictionary': '词典',
  'menu.question': '问题',
  'menu.nlp': 'NLP',
  'menu.form.new-flow': '新流程',
  'menu.form.update-flow': '编辑流程',
  'menu.list.flow-list': '流程列表',
  'menu.divider': '分隔线',
  'menu.favouritesHub': '项目',
  'menu.translation': '翻译',
  'menu.comparison': '对比',
  'menu.scribe': '录音',
  'menu.organisation': '机构',
  'menu.entity': '实体',
  'menu.flow': '流程',
  'menu.filesNew': '文件（新版）',
  'menu.filesRefactored': '文件（重构版）',
  'menu.superAdminOrganisation': '超级管理员机构',
  'menu.section.vault': '保管库',
  'menu.section.chatAndCompose': '聊天与撰写',
  'menu.section.specialised': '专业功能',
  'menu.section.system': '系统',
};
